import { render, staticRenderFns } from "./Alapatarea.vue?vue&type=template&id=18257cb8&scoped=true&"
import script from "./Alapatarea.vue?vue&type=script&lang=js&"
export * from "./Alapatarea.vue?vue&type=script&lang=js&"
import style0 from "./Alapatarea.vue?vue&type=style&index=0&id=18257cb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18257cb8",
  null
  
)

export default component.exports